import { BrowserRouter, Routes } from "react-router-dom";

import PublicRoutes from "./public.routes";
import AdminRoutes from "./admin.routes";
import StaffRoutes from "./staff.routes";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {PublicRoutes()}
        {AdminRoutes()}
        {StaffRoutes()}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;